import { map } from 'lodash/fp';
import { useStepperContext } from '@ahmdigital/ui';
import Icon from '@ahmdigital/icons-web';
import React from 'react';

import { StepName, StepNumber, StepWrapper, StyledClickable } from '../styles';
import uncapFpIterator from '../../../../../../utils/uncap-fp-iterator';
import useActiveIndex from '../../../hooks/use-active-index';
import type { StepHeaderNavigationProps } from '../types';

const mapWithIndex = uncapFpIterator(map);

const StepNavigation = ({ hasStepZero = false, isMobile = false, handleGoToStep }: StepHeaderNavigationProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'activeStep' does not exist on type '{}'.
  const { activeStep, steps } = useStepperContext();
  const activeIndex = useActiveIndex();

  return (
    <>
      {mapWithIndex((step: string, index: number) => {
        const isActive = activeStep === step;
        const isBeforeActiveStep = index < activeIndex;
        const isAfterActiveStep = index > activeIndex;
        if (hasStepZero && step === steps[0]) {
          return null;
        }
        const stepNumber = hasStepZero ? index : index + 1;
        return (
          <StepWrapper key={step} isMobile={isMobile}>
            <StyledClickable disabled={isAfterActiveStep} isUnstyled onClick={() => handleGoToStep(step)}>
              <StepNumber $isActive={isActive} $isBeforeActiveStep={isBeforeActiveStep}>
                {isBeforeActiveStep ? <Icon name="tick" width={12} height={12} /> : stepNumber}
              </StepNumber>
              <StepName $isActive={isActive} $isBeforeActiveStep={isBeforeActiveStep}>
                {step}
              </StepName>
            </StyledClickable>
          </StepWrapper>
        );
      }, steps)}
    </>
  );
};

export default StepNavigation;
